import { ButtonMui } from 'src/components/ButtonMui'
import TextFieldMui from 'src/components/TextFieldMui'
import theme from 'src/styles/theme'
import styled from 'styled-components'

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  padding: .8rem;
`
export const ContainerRows = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 40vh;
  overflow-y: auto;
`

export const ContainerFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
`

export const Row = styled.div`
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  padding: .4rem;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 25%;
`

export const CustomTextField = styled(TextFieldMui)`
  margin: 0 !important;
  width: 80% !important;
`

export const CustomButton = styled(ButtonMui)`
  width: 12rem;    
  height: 2.5rem !important;
  margin: 0 !important;
`

export const TotalSelectedQuantity = styled.div`
  display: flex;
  align-items: center;
  gap: .5rem;
`

export const ContainerCounter = styled.div`
  display: flex;
  align-items: center;
  padding: .5rem;
  border-radius: 5px;
  height: 2.5rem;
  background-color: ${theme.colors.orange};
  color: ${theme.colors.white}
`
